import * as React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useState, useEffect } from "react";

import "./Experience.css";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { BsCheckCircle } from "react-icons/bs";
import Modal from "react-modal";

Modal.setAppElement("#root");

const TopLeft = {
	offScreen: {
		opacity: 0,
		x: -100,
		y: -100,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, 340],
		transition: {
			type: "spring",
			bounce: 0.7,
			duration: 2,
			layout: { duration: 3 },
		},
		layout: "position",
	},
};
const TopRight = {
	offScreen: {
		opacity: 0,
		x: 100,
		y: -100,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, -340],
		transition: { type: "spring", bounce: 0.7, duration: 3 },
	},
};
const LeftIn = {
	offScreen: {
		opacity: 0,
		x: -100,
		y: 0,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, 370],
		transition: { type: "spring", bounce: 0.7, duration: 2 },
	},
};

const RightIn = {
	offScreen: {
		opacity: 0,
		x: 100,
		y: 0,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, -370],
		transition: { type: "spring", bounce: 0.7, duration: 3 },
	},
};

const BottomLeft = {
	offScreen: {
		opacity: 0,
		x: -100,
		y: 100,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, 340],
		transition: { type: "spring", bounce: 0.7, duration: 2 },
	},
};

const BottomRight = {
	offScreen: {
		opacity: 0,
		x: 100,
		y: 100,
	},
	onScreen: {
		opacity: 1,
		x: 0,
		y: 0,
		rotate: [0, -340],
		transition: { type: "spring", bounce: 0.7, duration: 3 },
	},
};

export function Experience() {
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		const body = document.querySelector('#root');
		body.style.overflow = modalIsOpen ? 'hidden' : '';
	  }, [modalIsOpen])

	const modalCustomStyles = {
		// disable scroll on body
		overlay: {
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: "rgba(0, 0, 0, 0.75)",
			zIndex: 1000,
			cursor: "pointer",

		},
		content: {
			position: "absolute",
			top: "80px",
			left: "80px",
			right: "80px",
			bottom: "80px",
			border: "1px solid #ccc",
			background: "#fff",
			overflow: "auto",
			WebkitOverflowScrolling: "touch",
			borderRadius: "20px",
			outline: "none",
			padding: "20px",
			// fit content
			width: "auto",
			height: "auto",
			// center content
			margin: "auto",
			
		},
	};

	return (
		<motion.section
			id="#experience"
			transition={{ staggerChildren: 0.5 }}
			initial={"offScreen"}
		>
			<h5>What Skills I Have</h5>
			<h2>Experience</h2>

			<div className="container experience__container">
				<motion.div
					// [ ] AOS Animation
					data-aos="fade-right"
					data-aos-offset="300"
					data-aos-easing="ease-out-cubic"
					data-aos-duration="1500"
					data-aos-anchor-placement="top-bottom"
					// [x] End of AOS Animation

					// [ ] Framer Motion Animation
					// className="experience__fontend"
					// variants={container}
					// whileInView={"onScreen"}
					// viewport = {{once: false, amount: 0.3}}
					// [x] End of Framer Motion Animation
				>
					<h3>Frontend Development</h3>
					<div className="experience__content">
						{/* [ ] Item One */}
						<motion.article
							className="experience__details"
							variants={TopLeft}
							whileHover={{ scale: 1.2, rotate: 360 }}
							whileInView={"onScreen"}
							onClick={() => {
								setModalIsOpen(true)}}
						>
							<BsFillPatchCheckFill className="experience__icon" />
							<motion.div>
								<h4>React</h4>
								<small>Expert</small>
							</motion.div>
						</motion.article>
						<AnimatePresence>
							{modalIsOpen && (
						<Modal
							isOpen={modalIsOpen}
							onRequestClose={() => setModalIsOpen(false)}
							style={modalCustomStyles}
						>
							<motion.p>Hellow</motion.p>
							<motion.img
								src={"https://cdn.worldvectorlogo.com/logos/react-2.svg"}
								alt={"https://cdn.worldvectorlogo.com/logos/react-2.svg"}
								
							/>
							<motion.p>hello</motion.p>
						</Modal>
					)}
						</AnimatePresence>

						{/* [x] End of Item One */}

						{/* [ ] Item Two */}
						<motion.article
							className="experience__details"
							variants={TopRight}
							whileHover={{ scale: 1.2, rotate: -360 }}
							whileInView={"onScreen"}
						>
							<BsFillPatchCheckFill className="experience__icon" />
							<div>
								<h4>CSS</h4>
								<small>Expert</small>
							</div>
						</motion.article>
						{/* [x] End of Item Two */}

						{/* [ ] Item Three */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 360 }}
							variants={LeftIn}
							whileInView={"onScreen"}
						>
							<BsFillPatchCheckFill className="experience__icon" />
							<div>
								<h4>JavaScript</h4>
								<small>Expert</small>
							</div>
						</motion.article>
						{/* [x] End of Item Three */}

						{/* [ ] Item Four */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -360 }}
							variants={RightIn}
							whileInView={"onScreen"}
						>
							<BsFillCheckCircleFill className="experience__icon" />
							<div>
								<h4>Bootstrap</h4>
								<small>Intermediate</small>
							</div>
						</motion.article>
						{/* [x] End of Item Four */}

						{/* [ ] Item Five */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 340 }}
							variants={LeftIn}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>Tailwind</h4>
								<small>Beginner</small>
							</div>
						</motion.article>
						{/* [x] End of Item Five */}

						{/* [ ] Item Six */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -340 }}
							variants={RightIn}
							whileInView={"onScreen"}
						>
							<BsFillPatchCheckFill className="experience__icon" />
							<div>
								<h4>HTML</h4>
								<small>Expert</small>
							</div>
						</motion.article>
						{/* [x] End of Item Six */}

						{/* [ ] Item Seven */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 360 }}
							variants={BottomLeft}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>jQuery</h4>
								<small>Intermediate</small>
							</div>
						</motion.article>
						{/* [x] End of Item Seven */}

						{/* [ ] Item Eight */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -360 }}
							variants={BottomRight}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>SaaS/Scss</h4>
								<small>Intermediate</small>
							</div>
						</motion.article>
						{/* [x] End of Item Eight */}
					</div>
				</motion.div>

				{/* Backend Skills */}
				<div
					className="experience__backend"
					data-aos="fade-left"
					data-aos-offset="300"
					data-aos-easing="ease-out-cubic"
					data-aos-duration="1500"
					data-aos-anchor-placement="top-bottom"
				>
					<h3>Backend Development</h3>
					<div className="experience__content">
						{/* [ ] Item One */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 360 }}
							variants={TopLeft}
							whileInView={"onScreen"}
						>
							<BsFillPatchCheckFill className="experience__icon" />
							<div>
								<h4>Node JS</h4>
								<small>Expert</small>
							</div>
						</motion.article>
						{/* [x] End of Item One */}

						{/* [ ] Item Two */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -360 }}
							variants={TopRight}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>PHP</h4>
								<small>Beginner</small>
							</div>
						</motion.article>
						{/* [x] End of Item Two */}

						{/* [ ] Item Three */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 340 }}
							variants={LeftIn}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>Python</h4>
								<small>Beginner</small>
							</div>
						</motion.article>
						{/* [x] End of Item Three */}

						{/* [ ] Item Four */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -340 }}
							variants={RightIn}
							whileInView={"onScreen"}
						>
							<BsCheckCircle className="experience__icon" />
							<div>
								<h4>MySQL</h4>
								<small>Beginner</small>
							</div>
						</motion.article>
						{/* [x] End of Item Four */}

						{/* [ ] Item Five */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: 360 }}
							variants={BottomLeft}
							whileInView={"onScreen"}
						>
							<BsFillCheckCircleFill className="experience__icon" />
							<div>
								<h4>MongoDB</h4>
								<small>Intermediate</small>
							</div>
						</motion.article>
						{/* [x] End of Item Five */}

						{/* [ ] Item Six */}
						<motion.article
							className="experience__details"
							whileHover={{ scale: 1.2, rotate: -360 }}
							variants={BottomRight}
							whileInView={"onScreen"}
						>
							<BsFillCheckCircleFill className="experience__icon" />
							<div>
								<h4>Express</h4>
								<small>Intermediate</small>
							</div>
						</motion.article>
						{/* [x] End of Item Six */}
					</div>
				</div>
			</div>
		</motion.section>
	);
}

// ===================================
